import { parse as parseParams } from 'hub-http/helpers/params';
import * as Tiers from 'marketplace-ui-common/constants/groupTags/Tiers';
import includes from '../utils/includes';
import replaceAll from '../utils/replaceAll';
import * as AssetSort from '../common/constants/AssetSort';
import filterIncludes from './filterIncludes';
const ASSET_QUERY_PARAM_FIELDS = ['hasFreeSupport', 'minOverallRating', 'offeringIds', 'planType', 'portalCompatible', 'priceRangeMin', 'priceRangeMax', 'providers', 'search', 'sortFields', 'tags', 'tiers'];
const AssetSortValues = Object.values(AssetSort);
const TierTypeValues = Object.values(Tiers);

function toArray(param) {
  return Array.isArray(param) ? param : [param];
}

export function getAssetQueryFromLocation(search, parseParam) {
  const params = parseParams(replaceAll(search.slice(1), '+', '%20'));
  const filteredParams = Object.keys(params).reduce((record, paramKey) => {
    if (!/^eco_/i.test(paramKey)) {
      return record;
    }

    const paramValue = params[paramKey];
    const unprefixedParamKey = paramKey.replace(/^eco_/i, '');

    if (includes(ASSET_QUERY_PARAM_FIELDS, unprefixedParamKey)) {
      parseAssetQueryValue(record, unprefixedParamKey, paramValue);
    } else if (parseParam) {
      parseParam(record, unprefixedParamKey, paramValue);
    }

    return record;
  }, {});
  return filteredParams;
}
export function parseAssetQueryValue(record, key, paramValue) {
  switch (key) {
    case 'hasFreeSupport':
    case 'portalCompatible':
      record[key] = paramValue === 'true' ? true : null;
      break;

    case 'tags':
    case 'providers':
      record[key] = toArray(paramValue);
      break;

    case 'offeringIds':
      record.offeringIds = toArray(paramValue).reduce((ids, id) => {
        const parsed = parseInt(id, 10);
        if (isNaN(parsed)) return ids;
        return ids.concat([parsed]);
      }, []);
      break;

    case 'planType':
      record.priceRange = null;
      record.planType = includes(['ONE_TIME', 'FREE'], paramValue) ? paramValue : null;
      break;

    case 'sortFields':
      record.sortFields = filterIncludes(toArray(paramValue), AssetSortValues);
      break;

    case 'tiers':
      record.tiers = filterIncludes(toArray(paramValue), TierTypeValues);
      break;

    case 'minOverallRating':
      {
        const parsedQueryValue = parseInt(paramValue, 10);
        record.minOverallRating = !isNaN(parsedQueryValue) && parsedQueryValue > 0 && parsedQueryValue < 5 ? parsedQueryValue : null;
        break;
      }

    case 'priceRangeMin':
    case 'priceRangeMax':
      {
        if (record.planType) return;
        const priceRangeKey = key === 'priceRangeMin' ? 'minCents' : 'maxCents';
        record.priceRange = Object.assign({}, record.priceRange || {
          minCents: null,
          maxCents: null
        }, {
          [priceRangeKey]: parseInt(paramValue, 10)
        });
        break;
      }

    case 'search':
      record.search = paramValue;
      break;

    default:
      {
        /* exhaustiveness check to flag missing params */
        const unknownKey = key;
        throw new Error(`Unknown search param: ${unknownKey}`);
      }
  }
}